import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { CONTROL } from '../../../../components';
import { generateRamItems } from '../../../utils';
var DeploymentMode = /*#__PURE__*/function (DeploymentMode) {
  DeploymentMode["Standard"] = "standart";
  DeploymentMode["Business"] = "business";
  return DeploymentMode;
}(DeploymentMode || {});
var deploymentModes = [{
  label: 'Стандарт',
  value: DeploymentMode.Standard,
  description: 'Для тестирования и несложных приложений'
}, {
  label: 'Бизнес',
  value: DeploymentMode.Business,
  description: 'Для высоконагруженных сервисов'
}];
var ClusterType = /*#__PURE__*/function (ClusterType) {
  ClusterType["Single"] = "single";
  ClusterType["Master_Replica"] = "master/replica";
  return ClusterType;
}(ClusterType || {});
var clusterTypeItems = [{
  label: 'Single',
  value: ClusterType.Single,
  description: 'Одноузловая конфигурация'
}, {
  label: 'Master/Replica',
  value: ClusterType.Master_Replica,
  description: 'Отказоустойчивый кластер высокой доступности'
}];
var vCpuMap = _defineProperty(_defineProperty({}, DeploymentMode.Standard, _defineProperty(_defineProperty({}, ClusterType.Single, [1, 2]), ClusterType.Master_Replica, [1, 2])), DeploymentMode.Business, _defineProperty(_defineProperty({}, ClusterType.Single, [4, 8]), ClusterType.Master_Replica, [4, 8]));
var ramMap = _defineProperty(_defineProperty({}, DeploymentMode.Standard, _defineProperty(_defineProperty({}, ClusterType.Single, {
  '1': [2, 4, 8],
  '2': [4, 8, 16],
  '4': [8, 16],
  '8': [32]
}), ClusterType.Master_Replica, {
  '1': [2, 4, 8],
  '2': [4, 8, 16],
  '4': [8]
})), DeploymentMode.Business, _defineProperty(_defineProperty({}, ClusterType.Single, {
  '4': [8, 16],
  '8': [32],
  '16': [32, 64, 128],
  '24': [48],
  '32': [64, 128, 256],
  '64': [128, 256]
}), ClusterType.Master_Replica, {
  '4': [8, 16],
  '8': [16, 32, 64],
  '16': [16, 64, 128, 256],
  '24': [48],
  '32': [64, 128, 256],
  '64': [128, 256]
}));
var ramAmount = generateRamItems([2, 4, 8, 16, 32]);
var getMinMaxDiskSize = function getMinMaxDiskSize(_ref) {
  var deploymentMode = _ref.deploymentMode;
  switch (deploymentMode) {
    case DeploymentMode.Business:
      {
        return {
          uiProps: {
            min: 40,
            max: 16000
          }
        };
      }
    case DeploymentMode.Standard:
    default:
      {
        return {
          uiProps: {
            min: 10,
            max: 2000
          }
        };
      }
  }
};
export var EVOLUTION_POSTGRE_SQL_FORM_CONFIG = {
  ui: ['deploymentMode', 'clusterType', 'flavorConfig', ['systemDisk']],
  controls: {
    deploymentMode: {
      type: CONTROL.Carousel,
      accessorKey: 'deploymentMode',
      defaultValue: DeploymentMode.Standard,
      items: deploymentModes,
      decoratorProps: {
        label: 'Режим развертывания',
        labelTooltip: 'Режимы развертывания кластера отличаются объемом ресурсов и уровнем безопасности'
      },
      onChangeFn: function onChangeFn(value, setValue) {
        setValue([['deploymentMode', value], ['systemDisk.diskSpace', 0]]);
      }
    },
    clusterType: {
      type: CONTROL.Carousel,
      accessorKey: 'clusterType',
      defaultValue: 'single',
      items: clusterTypeItems,
      decoratorProps: {
        label: 'Тип кластера'
      }
    },
    flavorConfig: {
      type: CONTROL.Object,
      ui: [['vCpu', 'ram']],
      controls: {
        vCpu: {
          type: CONTROL.Slider,
          accessorKey: 'flavorConfig.vCpu',
          defaultValue: '1',
          items: [],
          decoratorProps: {
            label: 'Количество ядер vCPU',
            labelTooltip: 'Виртуальные ядра'
          },
          watchedControls: {
            deploymentMode: 'deploymentMode',
            clusterType: 'clusterType'
          },
          relateFn: function relateFn(_ref2) {
            var _vCpuMap$deploymentMo;
            var deploymentMode = _ref2.deploymentMode,
              clusterType = _ref2.clusterType;
            var items = vCpuMap === null || vCpuMap === void 0 ? void 0 : (_vCpuMap$deploymentMo = vCpuMap[deploymentMode]) === null || _vCpuMap$deploymentMo === void 0 ? void 0 : _vCpuMap$deploymentMo[clusterType];
            if ((items === null || items === void 0 ? void 0 : items.length) > 0) {
              return {
                items: items
              };
            }
          }
        },
        ram: {
          type: CONTROL.Segmented,
          accessorKey: 'flavorConfig.ram',
          defaultValue: '2',
          items: ramAmount.slice(0, 3),
          decoratorProps: {
            label: 'Количество оперативной памяти (RAM)'
          },
          watchedControls: {
            deploymentMode: 'deploymentMode',
            clusterType: 'clusterType',
            vCpu: 'flavorConfig.vCpu'
          },
          relateFn: function relateFn(_ref3) {
            var _ramMap$deploymentMod, _ramMap$deploymentMod2;
            var deploymentMode = _ref3.deploymentMode,
              clusterType = _ref3.clusterType,
              vCpu = _ref3.vCpu;
            var items = ramMap === null || ramMap === void 0 ? void 0 : (_ramMap$deploymentMod = ramMap[deploymentMode]) === null || _ramMap$deploymentMod === void 0 ? void 0 : (_ramMap$deploymentMod2 = _ramMap$deploymentMod[clusterType]) === null || _ramMap$deploymentMod2 === void 0 ? void 0 : _ramMap$deploymentMod2[vCpu];
            if ((items === null || items === void 0 ? void 0 : items.length) > 0) {
              return {
                items: generateRamItems(items)
              };
            }
          }
        }
      }
    },
    systemDisk: {
      type: CONTROL.Object,
      ui: [{
        controls: ['diskSpace', 'specification']
      }],
      controls: {
        diskSpace: {
          type: CONTROL.Stepper,
          decoratorProps: {
            label: 'Диск'
          },
          accessorKey: 'systemDisk.diskSpace',
          defaultValue: 10,
          uiProps: {
            min: 10,
            max: 2000,
            postfix: 'ГБ'
          },
          watchedControls: {
            deploymentMode: 'deploymentMode'
          },
          relateFn: getMinMaxDiskSize
        },
        specification: {
          type: CONTROL.SelectSingle,
          accessorKey: 'systemDisk.specification',
          decoratorProps: {
            label: ''
          },
          defaultValue: 'SSD',
          items: [{
            value: 'SSD',
            label: 'SSD'
          }],
          uiProps: {
            disabled: true,
            showClearButton: false,
            searchable: false
          }
        }
      }
    }
  }
};